<template>
  <div class="ancap-stars" :title="`${stars}/${ratingLimit} stars`">
    <img :src="ANCAPStarBlack" alt="A black star icon" width="24" v-for="star in stars" :key="star" />
    <img :src="ANCAPStarEmpty" alt="An empty star icon" width="24" v-for="star in remainingStars" :key="star" />
  </div>
</template>

<script setup lang="ts">
import ANCAPStarBlack from '@/assets/img/ancap-star-black.svg';
import ANCAPStarEmpty from '@/assets/img/ancap-star-black-outline.svg';
import { computed } from 'vue';

const props = defineProps({
  stars: {
    type: Number,
    required: true,
  },
  ratingLimit: {
    type: Number,
    default: 5,
  },
});

const remainingStars = computed(() => props.ratingLimit - props.stars);
</script>

<style scoped lang="scss">
.ancap-stars {
  display: flex;
  gap: 0;

  @media screen and (min-width: #{$breakpoint-sm}) {
    gap: 0.5rem;
  }
}
</style>
